module.exports = __webpack_public_path__ + "img/m-banner-ltwjyxtc-ja-JP.f4a72c10.jpg";